import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import '../NotFound.scss';
import Icon from '../../../../components/icons/Icon';

class NotFoundScene extends React.Component {

    public render() {
        return <React.Fragment>
            <PageContent pageName="[ERROR] Not Found">
                <PageBody>
                    <div className="notfound-content">
                        <h1>Well this is awkward.</h1>
                        <Icon name="question" width="35rem" />
                        <h3>I can't find the thing you're looking for.</h3>
                    </div>
                </PageBody>
            </PageContent>
        </React.Fragment>
    }
}

export { NotFoundScene }